import React from 'react';
import { Helmet } from 'react-helmet-async';
const SEO = () => {
  const title = 'Settl | Automate Bill Payments for Malaysian SMEs with 30-Day Terms';
  const description = 'Settl helps Malaysian businesses automate bill payments with 30-day payment terms. Save time, improve cash flow, and never miss a payment again.';
  const url = 'https://settl.my'; // Replace with your actual URL
  const imageUrl = 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'; // Replace with your actual image
  return <Helmet data-id="element-312">
      {/* Basic Meta Tags */}
      <title data-id="element-313">{title}</title>
      <meta name="description" content={description} data-id="element-314" />
      {/* Open Graph Meta Tags for Facebook, LinkedIn */}
      <meta property="og:title" content={title} data-id="element-315" />
      <meta property="og:description" content={description} data-id="element-316" />
      <meta property="og:image" content={imageUrl} data-id="element-317" />
      <meta property="og:url" content={url} data-id="element-318" />
      <meta property="og:type" content="website" data-id="element-319" />
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-320" />
      <meta name="twitter:title" content={title} data-id="element-321" />
      <meta name="twitter:description" content={description} data-id="element-322" />
      <meta name="twitter:image" content={imageUrl} data-id="element-323" />
      {/* Additional SEO Tags */}
      <meta name="keywords" content="bill payments, Malaysian SMEs, payment automation, invoice management, cash flow, 30-day payment terms" data-id="element-324" />
      <meta name="author" content="Settl by RollingPay" data-id="element-325" />
      <link rel="canonical" href={url} data-id="element-326" />
    </Helmet>;
};
export default SEO;